import React from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, activeTab, onTabChange }) => {
  // intro 页面使用透明背景，让 Three.js 背景可见
  const isIntro = activeTab === 'intro';
  
  return (
    <div className={`flex h-screen w-screen overflow-hidden ${isIntro ? 'bg-transparent' : 'bg-[#fff5f7]'}`}>
      <Sidebar activeTab={activeTab} onTabChange={onTabChange} />
      <main className="flex-1 h-full overflow-hidden relative flex flex-col">
        {/* Soft decorative background circles - intro 页面隐藏 */}
        {!isIntro && (
          <>
            <div className="absolute top-[-10%] right-[-5%] w-[40%] h-[40%] bg-purple-100/20 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute bottom-[-10%] left-[-5%] w-[30%] h-[30%] bg-pink-100/20 rounded-full blur-[80px] pointer-events-none" />
          </>
        )}
        
        <div className="relative flex-1 w-full overflow-hidden">
          {children}
        </div>

        {/* ICP 备案号 */}
        <div className="relative z-10 flex-shrink-0 py-1 text-center text-xs text-gray-400">
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600 transition-colors"
          >
            蜀ICP备2020028680号-1
          </a>
        </div>
      </main>
    </div>
  );
};

export default Layout;
